/* ============
 * Routes File
 * ============
 */
// COMPONENTS
import CourseIndex from "features/courses/courses.vue";
import Settings from "features/courses/pages/settings/settings.vue";
import StudentSettings from "features/courses/pages/settings/studentSettings.vue";
// import ActivityIndex from 'features/onlineRoundtables/components/activityIndex';
import OnlineRoundtableIndex from "features/onlineRoundtables/rtIndex.vue";
import OnlineRoundtableFeed from "features/onlineRoundtables/pages/feed/feed";
import OnlineSubmitResponse from "features/onlineRoundtables/pages/submitResponsePage/submitResponsePage.vue";

import Dashboard from "features/dashboard/dashboard";
import MyCourses from "features/dashboard/myCourses";

import StudentActivitySummary from "features/studentActivitySummary/studentActivitySummary.vue";

import LiveDiscussion from "features/liveDiscussion/liveDiscussion.vue";
import OnlineWalkthroughIndex from "features/onlineWalkthrough/onlineWalkthrough.index.vue";
import publicChordDiagram from "components/dataVisualization/d3js/chordDiagramPublic";

import cleverError from "./errorPages/clever_error";

// Admin
import adminUniverseSettings from "features/admin/adminUniverseSettings.vue";
import adminManageCollections from "features/admin/adminManageCollections.vue";
import adminWelcomeModals from "features/admin/adminWelcomeModals.vue";
import AdminGeniePrompts from "features/admin/GeniePrompt/GeniePrompt.vue";
import adminEditCollection from "features/admin/adminEditCollection.vue";
import premadeForm from "features/courses/pages/premades/premadeForm.vue";
import livePremadeForm from "features/courses/pages/premades/livePremadeForm.vue";
import schoolManagement from "features/admin/schoolManagement.vue";
import viewIndividualSchool from "features/admin/viewIndividualSchool.vue";
import viewIndividualDistrict from "features/admin/viewIndividualDistrict.vue";
import viewIndividualUser from "features/admin/viewIndividualUser.vue";
import searchEditPremades from "features/admin/searchEditPremades.vue";
import authServices from "./features/authentication/authentication.services";
import adminPortal from "features/admin/adminPortal/adminPortal.vue";
import adminPortalUsers from "features/admin/adminPortal/adminPortalUsers/adminPortalUsers.vue";
import adminPortalAddUsers from "features/admin/adminPortal/adminPortalUsers/addUsers/adminPortalAddUsers.vue";
import comingSoon from "features/admin/adminPortal/comingSoon.vue";
import suggestionsTab from "features/admin/adminPortal/suggestions/suggestionsTab.vue";
import adminPortalCourses from "features/admin/adminPortal/courses/adminPortalCourses.vue";
import adminPortalAddCourses from "features/admin/adminPortal/courses/addCourses/adminPortalAddCourses.vue";
import adminPortalSchoolInfo from "features/admin/adminPortal/schoolInfo/adminPortalSchoolInfo.vue";
import adminMemberships from "features/admin/adminPortal/memberships/adminMemberships.vue";
import adminPortalAnalytics from "features/admin/adminPortal/analytics/adminPortalAnalytics.vue";
import adminViewUsers from "features/admin/adminPortal/adminPortalParlay/adminPortalParlayUsers/adminViewUsers.vue";
import adminPortalParlay from "features/admin/adminPortal/adminPortalParlay/adminPortalParlay.vue";
import adminViewAnalytics from "features/admin/adminPortal/adminPortalParlay/adminPortalParlayAnalytics/adminViewAnalytics.vue";
import adminPortalIntegrations from "features/admin/adminPortal/integrations/adminPortalIntegrations.vue";
import adminPortalIntegrationsRedirectComponent from "features/admin/adminPortal/integrations/adminPortalIntegrationsRedirectComponent.vue";

import generalSettings from "features/courses/pages/settings/generalSettings.vue";
import integrations from "features/courses/pages/settings/integrations.vue";
import ParticipantsTab from "features/courses/pages/settings/ParticipantsTable.vue";
import Banners from "features/courses/pages/settings/banners.vue";

import promptTab from "features/onlineRoundtables/tabs/promptTab.vue";
import settingsTab from "features/onlineRoundtables/tabs/settingsTab.vue";
import discussionTab from "features/onlineRoundtables/tabs/discussionTab.vue";
import IndividualSummaryTab from "features/onlineRoundtables/tabs/IndividualSummary.vue";
import summaryTab from "features/onlineRoundtables/tabs/summaryTab.vue";

import LDPromptTab from "features/liveDiscussion/tabs/LDPromptTab.vue";
import LDSettingsTab from "features/liveDiscussion/tabs/LDSettingsTab.vue";
import LDDiscussionTab from "features/liveDiscussion/tabs/LDDiscussionTab.vue";
import LDSummaryTab from "features/liveDiscussion/tabs/LDSummaryTab.vue";
import LDIndividualSummaryTab from "features/liveDiscussion/tabs/LDIndividualSummaryTab.vue";
import LDTranscriptionsTab from "./features/liveDiscussion/tabs/LDTranscriptionsTab.vue";

import StudentReport from "features/courses/pages/Reports/StudentReports.vue";
import SummaryTab from "features/courses/pages/Reports/SummaryTab.vue";
import DiscussionTab from "features/courses/pages/Reports/DiscussionStudentTab.vue";


import store from "store";
import Vue from "vue";

// Services
import createReferral from "services/account/createReferral";

import { EventBus } from "utils/event-bus";

const enforceAdmin = (to, from, next) => {
  setTimeout(() => {
    if (store.state.account.role !== "admin") {
      Vue.router.push({ name: "dashboard" });
    }
    next();
  }, 1000);
};

const enforceAdminPortalPermissions = (to, from, next) => {
  setTimeout(() => {
    if (store.state.account.role !== "admin") {
      if (
        store.getters.getProfile.school.admin_role !== "admin" &&
        store.getters.getProfile.school.admin_role !== "coach"
      ) {
        Vue.router.push({ name: "dashboard" });
      }
    }
    next();
  }, 1000);
};

const redirectToDashboardIfAuthenticated = (to, from, next) => {
  if (!authServices.redirectToAuthClient()) {
    if (store.state.auth.authenticated) {
      Vue.router.push({ name: "dashboard" });
    }

    next();
  }
};

const checkAuthClientRedirect = (to, from, next) => {
  if (!authServices.redirectToAuthClient()) {
    next();
  }
};

const enforcehasTeacherPermissionsInCourse = (to, from, next) => {
  setTimeout(() => {
    if (store.state.account.role === "student") {
      Vue.router.push({ name: "dashboard" });
    }
    next();
  }, 1000);
};

export default [
  {
    path: "/online-roundtable-demo",
    name: "walkthrough",
    component: OnlineWalkthroughIndex,
    meta: { auth: false },
    children: [
      {
        name: "walkthrough.feed",
        path: "",
        component: OnlineRoundtableFeed,
      },
    ],
  },

  // This route catches routes that do not exist
  {
    path: "*",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard", // dashboard of classes
    name: "dashboard",
    components: { dashboard: Dashboard },
    meta: { auth: true }, // user needs to be authenticated
    beforeEnter: checkAuthClientRedirect,
  },
  {
    path: "/classes",
    name: "my-courses",
    component: MyCourses,
    meta: { auth: true },
    beforeEnter: checkAuthClientRedirect,
  },
  {
    path: "/clever_error", // dashboard of classes
    name: "clever_error",
    component: cleverError,
  },
  {
    path: "/chord-diagram/:roundtableID",
    name: "chord-diagram",
    component: publicChordDiagram,
    meta: { auth: false },
  },
  // This is the form where the admin user can edit the details for an
  // existing premade roundtabe
  {
    path: "/premade-form/:premadeID",
    name: "premade-form",
    component: premadeForm,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },

  {
    path: "/live-premade-form/:premadeID",
    name: "live-premade-form",
    component: livePremadeForm,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  // This is the place where an admin user manage schools and their Memberships
  {
    path: "/admin-school-management",
    name: "admin-school-management",
    component: schoolManagement,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  // This is the place where an admin user manage schools and their Memberships
  {
    path: "/admin-view-individual-school/:schoolID",
    name: "admin-view-individual-school",
    component: viewIndividualSchool,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  {
    path: "/admin-view-individual-district/:districtID",
    name: "admin-view-individual-district",
    component: viewIndividualDistrict,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  {
    path: "/admin-view-individual-user/:userID",
    name: "admin-view-individual-user",
    component: viewIndividualUser,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  // This is the place where an admin user can edit the existing subjects and
  // grade levels that exist within the parlay universe
  {
    path: "/admin-universe-settings",
    name: "admin-universe-settings",
    component: adminUniverseSettings,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  {
    path: "/search-edit-premades",
    name: "search-edit-premades",
    component: searchEditPremades,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  {
    path: "/admin-manage-collections",
    name: "admin-manage-collections",
    component: adminManageCollections,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  {
    path: "/admin-welcome-modals",
    name: "admin-welcome-modals",
    component: adminWelcomeModals,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  {
    path: "/admin-genie-prompts",
    name: "admin-genie-prompts",
    component: AdminGeniePrompts,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  {
    path: "/admin-edit-collection/:collectionID",
    name: "admin-edit-collection",
    component: adminEditCollection,
    meta: { auth: true },
    beforeEnter: enforceAdmin,
  },
  {
    path: "/classes/:courseID",
    name: "course.index",
    component: CourseIndex,
    meta: { auth: true }, // user needs to be authenticated
    // children: [
    //   {
    //     path: 'roundtables',
    //     component: ActivityIndex,
    //     children: [
    //       {
    //         name: 'course.roundtables.default',
    //         path: '',
    //       },
    //       {
    //         name: 'roundtable.index',
    //         path: 'online/:roundtableID',
    //         component: OnlineRoundtableIndex,
    //         children: [
    //           {
    //             name: 'roundtable.feed',
    //             path: '',
    //             component: OnlineRoundtableFeed,
    //           },
    //           {
    //             name: 'roundtable.submit',
    //             path: 'submit',
    //             component: OnlineSubmitResponse,
    //           },
    //         ],
    //       },
    //       {
    //         path: 'live/:liveDiscussionID',
    //         name: 'live-discussion.index',
    //         component: LiveDiscussion,
    //       },
    //     ],
    //   },
    // ],
  },
  {
    name: "roundtable.index",
    path: "/classes/:courseID/roundtables/online/:roundtableID",
    component: OnlineRoundtableIndex,
    meta: { auth: true },
    children: [
      {
        name: "roundtable.prompt",
        path: "prompt",
        component: promptTab,
      },
      {
        name: "roundtable.settings",
        path: "settings",
        component: settingsTab,
      },
      {
        name: "roundtable.discussion",
        path: "discussion",
        component: discussionTab,
      },
      {
        name: "roundtable.summary",
        path: "summary",
        component: summaryTab,
      },
      {
        name: "roundtable.individual_summary",
        path: "individual_summary",
        component: IndividualSummaryTab,
        beforeEnter: enforcehasTeacherPermissionsInCourse,
      },
    ],
  },
  {
    name: "roundtable.submit",
    path: "/classes/:courseID/roundtables/online/:roundtableID/submit",
    component: OnlineSubmitResponse,
    meta: { auth: true },
  },
  {
    path: "/classes/:courseID/roundtables/live/:liveDiscussionID",
    name: "live-discussion.index",
    component: LiveDiscussion,
    meta: { auth: true },
    children: [
      {
        name: "live-discussion.prompt",
        path: "prompt",
        component: LDPromptTab,
      },
      {
        name: "live-discussion.settings",
        path: "settings",
        component: LDSettingsTab,
      },
      {
        name: "live-discussion.discussion",
        path: "discussion",
        component: LDDiscussionTab,
      },
      {
        name: "live-discussion.summary",
        path: "summary",
        component: LDSummaryTab,
      },
      {
        name: "live-discussion.individualSummary",
        path: "individualSummary",
        component: LDIndividualSummaryTab,
        beforeEnter: enforcehasTeacherPermissionsInCourse,
      },
      {
        name: "live-discussion.transcriptions",
        path: "transcriptions",
        component: LDTranscriptionsTab,
      },
    ],
  },
  //Individual Student Summary
  {
    path: "/classes/:courseID/student-summary/:studentID",
    name: "course.student-summary",
    component: StudentActivitySummary,
  },
  //Settings
  {
    name: "course.settings",
    path: "/classes/:courseID/settings",
    component: Settings,
    beforeEnter: enforcehasTeacherPermissionsInCourse,
    children: [
      {
        path: "general-settings",
        name: "course.settings.general",
        component: generalSettings,
        meta: {
          auth: true,
        },
      },
      {
        path: "integrations",
        name: "course.settings.integrations",
        component: integrations,
        meta: {
          auth: true,
        },
      },
      {
        path: "participants",
        name: "course.settings.participants",
        component: ParticipantsTab,
        meta: {
          auth: true,
        },
      },
      {
        path: "banners",
        name: "course.settings.banners",
        component: Banners,
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    name: 'student.settings',
    path: '/classes/:courseID/student-settings',
    component: StudentSettings,
  },

  // Student Report By Id

  {
    name: "student.reports",
    path: "/classes/:courseID/student/student-report/:studentID",
    component: StudentReport,
    children: [
      {
        path: "summary",
        name: "course.student-reports.summary",
        component: SummaryTab,
        meta: {
          auth: true,
        },
      },
      {
        path: "discussion",
        name: "course.student-reports.discussion",
        component: DiscussionTab,
        meta: {
          auth: true,
        },
      },
    ],
  },
  // Login
  {
    path: "/account/login",
    name: "login",
    component: require("features/authentication/login/login.vue"),
    beforeEnter: redirectToDashboardIfAuthenticated,
    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },
  {
    name: "admin-portal-parlay",
    path: "/admin-portal-parlay/",
    component: adminPortalParlay,
    children: [
      {
        path: "analytics",
        name: "admin-portal-parlay-analytics",
        component: adminViewAnalytics,
        meta: {
          //fullscreen: true,
          auth: true,
        },
      },
      {
        path: "users",
        name: "admin-portal-parlay-users",
        component: adminViewUsers,
        meta: {
          //fullscreen: true,
          auth: true,
        },
      },
    ],
  },
  {
    name: "admin-portal-integrations",
    path: "/admin-portal/integrations",
    component: adminPortalIntegrationsRedirectComponent,
    meta: {
      //fullscreen: true,
      auth: true,
    },
  },
  {
    name: "admin-portal",
    path: "/admin-portal/:schoolID",
    component: adminPortal,
    meta: {
      //fullscreen: true,
      auth: true,
    },
    beforeEnter: enforceAdminPortalPermissions,
    children: [
      {
        path: "analytics",
        name: "admin-analytics",
        component: adminPortalAnalytics,
        meta: {
          //fullscreen: true,
          auth: true,
        },
      },
      {
        path: "users",
        name: "admin-users",
        component: adminPortalUsers,
        meta: {
          //fullscreen: true,
          auth: true,
        },
      },
      {
        path: "add-users",
        name: "admin-add-users",
        component: adminPortalAddUsers,
        meta: {
          fullscreen: true,
          auth: true,
        },
      },
      {
        path: "courses",
        name: "admin-courses",
        component: adminPortalCourses,
        meta: {
          fullscreen: true,
          auth: true,
        },
      },
      {
        path: "add-courses",
        name: "admin-add-courses",
        component: adminPortalAddCourses,
        meta: {
          //fullscreen: true,
          auth: true,
        },
      },
      {
        path: "integrations",
        name: "admin-integrations",
        component: adminPortalIntegrations,
        meta: {
          //fullscreen: true,
          auth: true,
        },
      },
      {
        path: "suggestions",
        name: "admin-suggestions",
        component: suggestionsTab,
        meta: {
          //fullscreen: true,
          auth: true,
        },
      },
      {
        path: "resources",
        name: "admin-resources",
        component: comingSoon,
        meta: {
          // fullscreen: true,
          auth: true,
        },
      },
      {
        path: "book",
        name: "admin-book",
        component: comingSoon,
        meta: {
          //fullscreen: true,
          auth: true,
        },
      },
      {
        path: "memberships",
        name: "admin-memberships",
        component: adminMemberships,
        meta: {
          //fullscreen: true,
        },
      },
      {
        path: "schoolInfo",
        name: "admin-school-info",
        component: adminPortalSchoolInfo,
        meta: {
          fullscreen: true,
        },
      },
    ],
  },

  {
    path: "/acc",
    name: "newPassword",
    component: require("features/authentication/newPwd/newPwd.vue"),
  },

  // Profile
  {
    path: "/profile",
    name: "profile.index",
    component: require("features/profile/profile.vue"),
    beforeEnter(to, from, next) {
      if (store.state.account.role === "teacher" && (store.state.account.subjects.length === 0 && store.state.account.grade_levels.length === 0)) {
        Vue.router.push({ name: "dashboard" });
      }
      next();
    },


    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
    children: [
      {
        name: "profile.info",
        path: "basic_info",
        component: require("features/profile/profileTabs/basicInfoTab.vue"), //basicInfoTab,
        meta: {
          auth: true,
        },
      },
      {
        name: "profile.password",
        path: "password",
        component: require("features/profile/profileTabs/passwordTab.vue"), //passwordTab,
        meta: {
          auth: true,
        },
      },
      {
        name: "profile.membership",
        path: "membership",
        component: require("features/profile/profileTabs/membershipTab.vue"), //MembershipTab,
        meta: {
          auth: true,
        },
      },
      {
        name: "profile.security",
        path: "security",
        component: require("features/profile/profileTabs/SecurityTab.vue"), //SecurityTab,
        meta: {
          auth: true,
        },
      },
      {
        name: "profile.integrations",
        path: "integrations",
        component: require("features/profile/profileTabs/integrationsTab.vue"), //integrationsTab,
        meta: {
          auth: true,
        },
      },
    ]
  },

  {
    path: "/support_&_PD",
    name: "support_&_PD",
    component: require("features/support_&_PD/support_&_PD.vue"),
    meta: {
      auth: true,
    },
    beforeEnter(to, from, next) {
      if (store.state.account.role !== "teacher" || (store.state.account.subjects.length === 0 && store.state.account.grade_levels.length === 0)) {
        Vue.router.push({ name: "dashboard" });
      }
      next();
    },
  },

  // Onboarding
  {
    path: "/onboarding",
    name: "onboarding",
    component: require("features/onboarding/createCourse.vue"),
    beforeEnter(to, from, next) {
      if (store.state.account.role !== "teacher") {
        Vue.router.push({ name: "dashboard" });
      }
      next();
    },
    // If the user needs to be authenticated to view this page
    meta: {
      auth: true,
    },
  },

  // Register
  {
    path: "/account/signup",
    name: "signup",
    component: require("features/authentication/signup/signup_new.vue"),
    beforeEnter: redirectToDashboardIfAuthenticated,
    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },
  {
    path: "/account/signup/referral/:referring_user_id",
    name: "signup-with-referral",
    component: require("features/authentication/signup/signupReferral.vue"),
    beforeEnter(to, from, next) {
      // If the user is already authenticated, redirect them to the dashboard
      if (store.state.auth.authenticated) {
        return (
          createReferral(to.params.referring_user_id)
            .then(() => {
              EventBus.$emit("toast-msg", "Discount applied!");
              return null;
            })
            .catch(() => {
              EventBus.$emit(
                "toast-msg",
                "You have already been referred by another user"
              );
              return null;
            })
            // Redirect to dashboard if fail or success
            .then(() => {
              Vue.router.push("dashboard");
              return next();
            })
        );
      }
      return next();
    },
  },
  // TODO: Make the next paths into one object
  {
    path: "/",
    redirect: { name: "dashboard" },
  },
  /*   {
    path: '/admin-users-details-modal',
    component: require('features/admin/adminPortal/userDetailsModal/usersDetailsModal.vue')
  }, */
  {
    path: "/classes/:id",
    redirect: (to) => {
      const { params } = to;
      return {
        name: "course.tab",
        params: {
          id: params.id,
          courseTab: "roundtables",
        },
      };
    },
  },
  {
    path: "/roundtables",
    redirect: { name: "dashboard" },
  },
  {
    path: `/roundtables/${null}`,
    redirect: { name: "dashboard" },
  },
  {
    path: `/submission/${null}`,
    redirect: { name: "dashboard" },
  },
  {
    path: `/live-discussion/${null}`,
    redirect: { name: "dashboard" },
  },
];



// WEBPACK FOOTER //
// ./src/app/routes.js